import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './AppRouter';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN || "YOUR_DOMAIN.auth0.com"}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || "YOUR_CLIENT_ID"}
        authorizationParams={{
          redirect_uri: window.location.origin
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
      >
        <AppRouter />
      </Auth0Provider>
    </BrowserRouter>
  </React.StrictMode>
);
